import React from "react";

import { getPreviewFramePrintFontSize } from "@/utils/qrEditorHelper";

import { QRFRameToPrintProps } from "../types";

import { uriText } from "./uri";

import "../styles.scss";

export const RestaurantFrameToDownload = (
  props: QRFRameToPrintProps
): React.SVGProps<SVGSVGElement> => {
  const {
    text,
    textColor,
    frameColor,
    frameBackgroundColor,
    height = 1200,
    qrSvg,
    width = 900,
  } = props;

  const fontSize = getPreviewFramePrintFontSize(text?.length);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none">
      <style>
        {`
              @font-face {
                font-family: 'Nunito Sans';
                src: url(${uriText});
                font-weight: bold
              }
            `}
      </style>
      <g id="surface1">
        <path
          fillRule="nonzero"
          fill="white"
          fillOpacity="1"
          strokeWidth="1"
          stroke="#BFBFBF"
          d="M 8 0.5 L 88 0.5 C 92.142188 0.5 95.5 3.857813 95.5 8 L 95.5 120 C 95.5 124.142188 92.142188 127.5 88 127.5 L 8 127.5 C 3.857813 127.5 0.5 124.142188 0.5 120 L 0.5 8 C 0.5 3.857813 3.857813 0.5 8 0.5 Z M 8 0.5 "
          transform="matrix(12.5,0,0,12.5,0,0)"
        />

        <path
          stroke="none"
          fillRule="nonzero"
          fill={frameBackgroundColor}
          d="M 329.9375 435.222656 C 332.105469 429.957031 336.339844 425.808594 341.648438 423.742188 L 513.28125 357.015625 C 518.140625 355.125 523.527344 355.125 528.382812 357.015625 L 699.214844 423.429688 C 704.992188 425.675781 709.46875 430.378906 711.425781 436.257812 L 768.636719 607.84375 C 770.0625 612.117188 770.0625 616.742188 768.636719 621.015625 L 711.949219 791.035156 C 709.695312 797.792969 704.148438 802.929688 697.238281 804.65625 L 525.886719 847.484375 C 522.570312 848.3125 519.097656 848.3125 515.78125 847.484375 L 344.019531 804.554688 C 337.335938 802.882812 331.90625 798.015625 329.523438 791.546875 L 263.226562 611.636719 C 261.417969 606.734375 261.519531 601.335938 263.507812 596.507812 Z M 329.9375 435.222656 "
        />

        <path
          stroke="none"
          fillRule="evenodd"
          fill={frameColor}
          d="M 520.546875 838.011719 C 649.183594 838.011719 753.484375 734.789062 753.484375 607.394531 C 753.484375 480 649.183594 376.707031 520.546875 376.707031 C 391.910156 376.707031 287.683594 480 287.683594 607.394531 C 287.683594 734.789062 391.910156 838.011719 520.546875 838.011719 Z M 520.546875 895.609375 C 681.28125 895.609375 811.644531 766.582031 811.644531 607.394531 C 811.644531 448.210938 681.28125 319.1875 520.546875 319.1875 C 359.8125 319.1875 229.523438 448.210938 229.523438 607.394531 C 229.523438 766.582031 359.8125 895.609375 520.546875 895.609375 Z M 520.546875 895.609375 "
        />
        <path
          stroke="none"
          fillRule="evenodd"
          fill={frameColor}
          d="M 144.550781 286 C 144.550781 283.355469 142.351562 281.179688 139.675781 281.179688 C 135.675781 281.179688 134.894531 285.375 134.8125 285.921875 L 127.988281 430.257812 C 127.753906 431.429688 127.042969 432.433594 125.941406 433.058594 C 124.542969 433.914062 122.804688 433.914062 121.390625 433.058594 C 120.296875 432.355469 119.511719 431.269531 119.273438 430.027344 C 119.433594 382.847656 117.542969 334.265625 117.464844 287.085938 C 117.464844 283.902344 114.570312 281.488281 111.5 281.488281 C 108.449219 281.488281 105.699219 283.824219 105.464844 286.9375 L 93.851562 466.867188 C 92.828125 482.804688 99.734375 500.285156 111.429688 511.410156 C 131.761719 530.683594 139.210938 524.160156 139.996094 545.605469 C 141.960938 603.046875 140.226562 647.195312 134.492188 704.867188 C 131.992188 730.050781 129.402344 755.316406 127.675781 780.574219 C 126.179688 802.574219 125.164062 825.1875 126.582031 847.265625 L 126.582031 847.652344 C 126.582031 856.359375 129.011719 864.984375 135.445312 871.128906 C 140.546875 876.101562 147.523438 878.742188 154.664062 878.742188 C 161.890625 878.742188 168.878906 876.101562 173.980469 871.128906 C 180.414062 864.984375 182.847656 856.359375 182.847656 847.652344 L 182.847656 847.265625 C 184.261719 825.1875 183.246094 802.574219 181.75 780.574219 C 180.023438 755.316406 177.433594 730.050781 174.921875 704.867188 C 169.191406 647.195312 167.464844 603.046875 169.421875 545.605469 C 170.214844 524.160156 177.675781 530.683594 197.996094 511.410156 C 209.691406 500.285156 216.597656 482.804688 215.574219 466.867188 L 203.960938 286.9375 C 203.71875 283.824219 200.976562 281.488281 197.914062 281.488281 C 194.851562 281.488281 191.871094 283.902344 191.871094 287.085938 C 191.871094 334.265625 189.984375 382.847656 190.144531 430.027344 C 189.914062 431.269531 189.128906 432.355469 188.027344 433.058594 C 186.609375 433.914062 184.894531 433.914062 183.476562 433.058594 C 182.375 432.433594 181.671875 431.429688 181.429688 430.257812 L 174.53125 285.921875 C 174.53125 285.375 173.738281 281.179688 169.742188 281.179688 C 167.0625 281.179688 164.875 283.355469 164.875 286 L 159.070312 430.027344 C 158.828125 431.269531 158.125 432.355469 157.023438 433.058594 C 156.320312 433.449219 155.535156 433.675781 154.664062 433.675781 C 153.890625 433.675781 153.105469 433.449219 152.394531 433.058594 C 151.300781 432.355469 150.515625 431.269531 150.355469 430.027344 Z M 144.550781 286 "
        />
        <path
          stroke="none"
          fillRule="evenodd"
          fill={frameColor}
          d="M 842.820312 540.007812 C 842.277344 537.671875 842.113281 534.882812 841.886719 532.546875 C 841.492188 527.960938 841.253906 523.371094 841.015625 518.785156 C 840.472656 506.507812 840.308594 494.144531 840.308594 481.945312 C 840.394531 468.96875 840.699219 455.832031 841.722656 442.855469 L 841.722656 442.617188 C 843.765625 395.128906 852.007812 342.425781 878.539062 301.699219 L 878.617188 301.621094 C 880.890625 298.046875 884.109375 293.535156 887.566406 291.046875 C 888.273438 290.585938 890.078125 289.421875 891.011719 289.722656 C 892.199219 290.035156 893.296875 292.371094 893.675781 293.296875 C 895.253906 297.183594 895.722656 302.246094 895.722656 306.359375 C 895.722656 382.925781 895.882812 459.480469 896.980469 536.046875 C 897.132812 548.875 895.253906 561.460938 893.296875 574.050781 C 889.445312 598.851562 889.597656 624.339844 891.089844 649.292969 C 892.742188 675.875 895.960938 702.378906 899.015625 728.882812 C 903.410156 767.359375 907.964844 807.464844 905.605469 846.175781 L 905.605469 846.5625 C 905.605469 855.191406 902.941406 863.585938 896.980469 869.960938 C 892.199219 875.011719 885.597656 878.355469 878.617188 878.433594 C 872.332031 878.585938 866.6875 876.101562 862.292969 871.667969 C 855.847656 865.21875 852.707031 855.65625 851.378906 846.796875 C 850.117188 828.144531 850.671875 809.332031 851.847656 790.675781 C 853.183594 770.855469 855.304688 751.039062 857.574219 731.21875 C 860.480469 705.257812 863.699219 679.140625 865.425781 653.023438 C 867.070312 628.929688 867.625 604.128906 864.480469 580.113281 C 862.449219 564.574219 863.46875 562.085938 851.847656 550.574219 C 850.519531 549.097656 849.179688 547.699219 847.769531 546.386719 C 846.898438 545.597656 845.960938 544.824219 845.179688 543.898438 C 844.007812 542.722656 843.363281 541.484375 842.820312 540.007812 Z M 842.820312 540.007812 "
        />

        <g
          stroke="null"
          transform="matrix(6.2212 0 0 6.2212 0 -55)"
          id="svg_485">
          <g
            dangerouslySetInnerHTML={{ __html: qrSvg }}
            stroke="null"
            id="svg_486"></g>
        </g>
        <text
          x="515"
          y="1100.3999700784689"
          dominantBaseline="middle"
          textAnchor="middle"
          fill={textColor}
          fontFamily="Nunito Sans"
          style={{ fontSize }}>
          {text}
        </text>
      </g>
    </svg>
  );
};
